import { ReactNode } from "react";
import DBObject from "./DBObject";
import * as __d3ett from "../rocket/D3ETemplateTypes";
import Result from "../classes/Result";
import { StudioFeaturesPageProps } from "../components/StudioFeaturesPage";
import { StudioAppsPageProps } from "../components/StudioAppsPage";
import { ContactSupportProps } from "../components/ContactSupport";

export default class GlobalFunctions {
  public static save: (obj: DBObject) => Promise<Result<any>>;
  public static delete: (obj: DBObject) => Promise<Result<any>>;
  public static objectSave: (obj: DBObject, create: boolean) => void;
  public static fieldChanged: (
    obj: DBObject,
    field: number,
    oldValue: any
  ) => void;
  public static objectDelete: (obj: DBObject) => void;
  public static typeInt: (obj: string) => number;
  public static types: Array<__d3ett.D3ETemplateType>;
  public static ContactSupport: (props: ContactSupportProps) => ReactNode;
  public static StudioAppsPage: (props: StudioAppsPageProps) => ReactNode;
  public static StudioFeaturesPage: (
    props: StudioFeaturesPageProps
  ) => ReactNode;
}
